import { render, staticRenderFns } from "./ListItem2.vue?vue&type=template&id=5334ceaa&scoped=true"
import script from "./ListItem2.vue?vue&type=script&lang=js"
export * from "./ListItem2.vue?vue&type=script&lang=js"
import style0 from "./ListItem2.vue?vue&type=style&index=0&id=5334ceaa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5334ceaa",
  null
  
)

export default component.exports